import script from "./Resources.vue?vue&type=script&setup=true&lang=js"
export * from "./Resources.vue?vue&type=script&setup=true&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=f9612bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9612bce"]])

export default __exports__